import * as _ from "./utils/utils";

export default ({
    components: c,
    strings: s,
    useAsButton,
    inline,
    appClass,
    theme,
    lockOpacity: lo,
}) => {
    const hidden = (con) => (con ? "" : 'style="display:none" hidden');

    const root = _.createFromTemplate(`
      <div :ref="root" class="pickr">

        ${
            useAsButton
                ? ""
                : '<button type="button" :ref="button" class="pcr-button"></button>'
        }

        <div :ref="app" class="pcr-app ${
            appClass || ""
        }" data-theme="${theme}" ${
        inline ? 'style="position: unset"' : ""
    } aria-label="color picker dialog" role="form">
            <div class="pcr-area01" :obj="interaction">
                <button class="pcr-btn-close" type="button" :ref="close" aria-label="cancel and exit"></button>
                <div class="pcr-inner-wrap">
                    <div class="pcr-color-wrap">
                        <button type="button" class="pcr-current-color" :ref="color"></button>
                        <ul class="pcr-btn-wrap">
                            <li class="pcr-no-color" ${hidden(
                                c.interaction.clear
                            )}>
                                <button type="button" :ref="clear"><span>カラーなし</span></button>
                            </li>
                            <li class="pcr-clear" ${hidden(c.dropper)}>
                                <i class="fas fa-eye-dropper pointer" :ref="dropper" title="スポイト"></i>
                            </li>
                            <li class="pcr-clear">
                                <button type="button" :ref="undo" aria-label="clear and exit"><span :ref="last_color" class="pcr-color"></span><span>元のカラーに戻す</span></button>
                            </li>
                        </ul>
                    </div>
                    <ul class="pcr-main-btn-wrap">
                        <li class="pcr-save">
                            <button type="button" aria-label="save and exit" :ref="save" ><span>OK</span></button>
                        </li>
                        <li class="pcr-cancel">
                            <button type="button" aria-label="cancel and exit" :ref="cancel" ><span>キャンセル</span></button>
                        </li>
                    </ul>
                </div>
                <div class="pcr-interaction hide" ${hidden(
                    Object.keys(c.interaction).length
                )}>
                  <input :ref="result" class="pcr-result" type="text" spellcheck="false" ${hidden(
                      c.interaction.input
                  )}>

                  <input :arr="options" class="pcr-type" data-type="HEXA" value="${
                      lo ? "HEX" : "HEXA"
                  }" type="button" ${hidden(c.interaction.hex)}>
                  <input :arr="options" class="pcr-type" data-type="RGBA" value="${
                      lo ? "RGB" : "RGBA"
                  }" type="button" ${hidden(c.interaction.rgba)}>
                  <input :arr="options" class="pcr-type" data-type="HSLA" value="${
                      lo ? "HSL" : "HSLA"
                  }" type="button" ${hidden(c.interaction.hsla)}>
                  <input :arr="options" class="pcr-type" data-type="HSVA" value="${
                      lo ? "HSV" : "HSVA"
                  }" type="button" ${hidden(c.interaction.hsva)}>
                  <input :arr="options" class="pcr-type" data-type="CMYK" value="CMYK" type="button" ${hidden(
                      c.interaction.cmyk
                  )}>

                  <input :ref="-clear" class="pcr-clear" value="${
                      s.clear || "Clear"
                  }" type="button" ${hidden(
        c.interaction.clear
    )} aria-label="clear and exit">
                </div>
            </div>
            <!-- /pcr-recent-swatches -->
            <div class="pcr-area02">
                <div class="pcr-recent-swatches-block pcr-swatches-block">
                    <p class="pcr-swatches-title">最近使ったカラー</p>
                    <div class="pcr-swatches" :ref="histories"></div>
                </div>
                <!-- /pcr-recent-swatches -->
                <div class="pcr-basic-swatches-block pcr-swatches-block">
                    <p class="pcr-swatches-title">基本カラー</p>
                    <div class="pcr-swatches ${
                        c.palette ? "" : "pcr-last"
                    }" :ref="swatches"></div>
                </div>
                <!-- /pcr-basic-swatches-block -->
                <div class="pcr-bottom-wrap">
                    <div class="pcr-selection-wrap">

                      <div class="pcr-selection" ${hidden(c.palette)}>
                        <div :obj="preview" class="pcr-color-preview" ${hidden(
                            c.preview
                        )}>
                          <button type="button" :ref="lastColor" class="pcr-last-color" aria-label="use previous color"></button>
                          <div :ref="currentColor" class="pcr-current-color"></div>
                        </div>

                        <div :obj="palette" class="pcr-color-palette">
                          <div :ref="picker" class="pcr-picker"></div>
                          <div :ref="palette" class="pcr-palette" tabindex="0" aria-label="color selection area" role="listbox"></div>
                        </div>

                        <div :obj="hue" class="pcr-color-chooser" ${hidden(
                            c.hue
                        )}>
                          <div :ref="picker" class="pcr-picker"></div>
                          <div :ref="slider" class="pcr-hue pcr-slider" tabindex="0" aria-label="hue selection slider" role="slider"></div>
                        </div>

                        <div :obj="opacity" class="pcr-color-opacity" ${hidden(
                            c.opacity
                        )}>
                          <div :ref="picker" class="pcr-picker"></div>
                          <div :ref="slider" class="pcr-opacity pcr-slider" tabindex="0" aria-label="opacity selection slider" role="slider"></div>
                        </div>
                      </div>
                    </div>
                    <!-- /pcr-selection-wrap -->
                    <div class="pcr-primary-wrap">
                        <div class="pcr-primary">
                            <div class="pcr-primary-color pcr-red" ${hidden(
                                !c.interaction.cmyk
                            )}>
                                <div class="pcr-name">R</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_r" min="0" max="255" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_r_text" type="number" min="0" max="255" tabindex="1"></div>
                            </div>
                            <div class="pcr-primary-color pcr-green" ${hidden(
                                !c.interaction.cmyk
                            )}>
                                <div class="pcr-name">G</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_g" min="0" max="255" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_g_text" type="number" min="0" max="255" tabindex="2"></div>
                            </div>
                            <div class="pcr-primary-color pcr-blue" ${hidden(
                                !c.interaction.cmyk
                            )}>
                                <div class="pcr-name">B</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_b" min="0" max="255" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_b_text" type="number" min="0" max="255" tabindex="3"></div>
                            </div>
                            <div class="pcr-primary-color pcr-cyan" ${hidden(
                                c.interaction.cmyk
                            )}>
                                <div class="pcr-name">C</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_c" min="0" max="100" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_c_text" type="number" min="0" max="100" tabindex="4"></div>
                            </div>
                            <div class="pcr-primary-color pcr-magenta" ${hidden(
                                c.interaction.cmyk
                            )}>
                                <div class="pcr-name">M</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_m" min="0" max="100" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_m_text" type="number" min="0" max="100" tabindex="5"></div>
                            </div>
                            <div class="pcr-primary-color pcr-yellow" ${hidden(
                                c.interaction.cmyk
                            )}>
                                <div class="pcr-name">Y</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_y" min="0" max="100" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_y_text" type="number" min="0" max="100" tabindex="6"></div>
                            </div>
                            <div class="pcr-primary-color pcr-keyplate" ${hidden(
                                c.interaction.cmyk
                            )}>
                                <div class="pcr-name">K</div>
                                <div class="pcr-chooser">
                                    <input type="range" :ref="color_k" min="0" max="100" tabindex="-1">
                                </div>
                                <div class="pcr-input"><input :ref="color_k_text" type="number" min="0" max="100" tabindex="7"></div>
                            </div>
                        </div>

                        <!-- /pcr-interaction -->
                    </div>
                    <!-- /pcr-interaction-wrap -->
                </div>
            </div>
        </div>
      </div>
    `);

    const int = root.interaction;

    // Select option which is not hidden
    int.options.find((o) => !o.hidden && !o.classList.add("active"));

    // Create method to find currenlty active option
    int.type = () => int.options.find((e) => e.classList.contains("active"));
    return root;
};
